// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2jGa1","title":"Info_title__2ZuXz","selects":"Info_selects__1JDBO","requiredAsterisk":"Info_requiredAsterisk__QODt6"};